import { render, staticRenderFns } from "./export_tch_sxsp_new.vue?vue&type=template&id=f14c0696&"
import script from "./export_tch_sxsp_new.vue?vue&type=script&lang=js&"
export * from "./export_tch_sxsp_new.vue?vue&type=script&lang=js&"
import style0 from "./export_tch_sxsp_new.vue?vue&type=style&index=0&id=f14c0696&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports